import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import type { LegalDoc } from '../data/legal';
type LegalModalProps = {
  doc: LegalDoc | null;
  onClose: () => void;
};
export function LegalModal({
  doc,
  onClose
}: LegalModalProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!doc) return;
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [doc, onClose]);
  return <AnimatePresence data-id="element-117" data-mp="1hsvdcykxhpdv">
      {doc ? <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-end justify-center bg-plum/60 p-0 backdrop-blur-sm sm:items-center sm:p-6" onClick={onClose} data-id="element-118" data-mp="1hrsqd1qq8738">
          <motion.div role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" initial={{
        y: 40,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 24,
        opacity: 0
      }} transition={{
        duration: 0.28,
        ease: 'easeOut'
      }} onClick={event => event.stopPropagation()} className="flex max-h-[88vh] w-full max-w-2xl flex-col overflow-hidden rounded-t-3xl bg-cream sm:rounded-3xl" data-id="element-119" data-mp="1fnorv5a3t9l8">
            <div className="flex items-start justify-between gap-6 border-b border-plum/10 px-6 py-5 sm:px-8" data-id="element-120" data-mp="11w1sgwkv7ky8">
              <h2 id="legal-modal-title" className="font-display text-2xl leading-tight text-plum sm:text-3xl" data-id="element-121" data-mp="16qo8jd1w61on">
                {doc.title}
              </h2>
              <button ref={closeRef} type="button" onClick={onClose} aria-label="Cerrar" className="rounded-full p-2 text-plum transition-colors hover:bg-blush/50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-plum" data-id="element-122" data-mp="67urfmitlfe5">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-123" data-mp="az2xc8kxyimk" />
              </button>
            </div>

            <div className="overflow-y-auto px-6 py-6 sm:px-8" data-id="element-124" data-mp="3jemqz8piy325">
              {doc.sections.map(section => <section key={section.heading} className="mb-7 last:mb-0" data-id="element-125" data-mp="3ehe2kqds92sg">
                  <h3 className="text-sm font-medium uppercase tracking-[0.16em] text-clay" data-id="element-126" data-mp="3te55vaqkuync">
                    {section.heading}
                  </h3>
                  {section.body.map(paragraph => <p key={paragraph} className="mt-3 text-base leading-relaxed text-ink/75" data-id="element-127" data-mp="18ki9ggiy2tcv">
                      {paragraph}
                    </p>)}
                </section>)}
              <p className="mt-8 border-t border-plum/10 pt-5 text-sm text-ink/50" data-id="element-128" data-mp="1b942iy6lp3yf">
                Última actualización: agosto de 2026 · Ingrid Rosales — Me Elijo
              </p>
            </div>
          </motion.div>
        </motion.div> : null}
    </AnimatePresence>;
}